/*jshint esversion: 6 */
/*jshint sub:true*/
// import axios from 'axios';
// import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  autopilots: []
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getAutopilots: (state, getters, rootState, rootGetters) => {
    let autopilots = rootGetters['Ultra/getUObjects']({type: 'autopilots'});
    let autopilots_sorted = [];
    autopilots.forEach(ap => {
      let aps = autopilots_sorted.find(el => el.type === ap.type);
      if (aps) {
        let apf = aps.functions.find(el => el.name === ap.function);
        if (apf) {
          apf.levels.push(ap);
        } else {
          aps.functions.push({
            name: ap.function,
            description: ap.description,
            levels: [ap],
          });
        }
      } else {
        autopilots_sorted.push({
          type: ap.type,
          functions: [{
            name: ap.function,
            description: ap.description,
            levels: [ap]
          }]
        });
      }
    });
    return autopilots_sorted;
  },
  getAutopilotProjects: (state, getters, rootState, rootGetters) => ids => {
    let autopilotprojects = rootGetters['Ultra/getUObjects']({type: 'autopilotprojects', ids: ids});
    let autopilotprojects_sorted = [];
    autopilotprojects.forEach(app => {
      let type = rootState.Ultra.autopilots[app.autopilots[0]].type;
      let apps = autopilotprojects_sorted.find(el => el.type === type);
      app.mapped_autopilot = rootState.Ultra.autopilots[app.autopilots[0]];
      //get levels
      app.levels = rootGetters['Ultra/getUObjectsFiltered']({type: 'autopilots', filter: {function: app.mapped_autopilot.function}});
      if (apps) {
        apps.autopilotprojects.push(app);
      } else {
        autopilotprojects_sorted.push({
          type: type,
          autopilotprojects: [app]
        });
      }
    });
    return autopilotprojects_sorted;
  },
  isFunctionInProject: (state, getters, rootState, rootGetters) => payload => {
    let autopilotprojects = rootGetters['Ultra/getUObjects']({type: 'autopilotprojects', ids: rootState.Ultra.projects[payload.project_id].autopilotprojects});
    let in_project = -1;
    autopilotprojects.forEach(app => {
      let ap = rootState.Ultra.autopilots[app.autopilots[0]];
      if (ap.function === payload.name) {
        in_project = ap.id;
        // in_project = ap.level;
      }
    });
    return in_project;
  }
};
// Actions
const actions = {
};
// Mutations
const mutations = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
